import { Controller } from "stimulus";
import Sortable from "sortablejs";
import { patch } from "@rails/request.js";

// Kanban board for tickets. Each column is a drop target; dragging a card to
// another column PATCHes the ticket's status (.../move). The DOM move is
// optimistic — on a server rejection we put the card back and surface the error.
export default class extends Controller {
  static targets = ["column", "count"];

  connect() {
    this.sortables = this.columnTargets.map((column) =>
      Sortable.create(column, {
        group: "tickets",
        draggable: "[data-ticket-id]",
        animation: 150,
        ghostClass: "opacity-40",
        onEnd: this.onEnd.bind(this),
      })
    );
  }

  disconnect() {
    this.sortables?.forEach((sortable) => sortable.destroy());
  }

  async onEnd(event) {
    const { item, to, from, oldIndex, newIndex } = event;
    if (to === from && oldIndex === newIndex) return; // reorder within a column: nothing to persist

    const status = to.dataset.status;
    const moveUrl = item.dataset.moveUrl;
    this.updateCounts();

    const response = await patch(moveUrl, { query: { status } });
    if (!response.ok) {
      this.revert(item, from, oldIndex);
      this.updateCounts();
      const body = await response.json.catch(() => ({}));
      if (body && body.error) window.alert(body.error);
    }
  }

  // Re-inserts a card at its original position when the server rejects the move.
  revert(item, from, oldIndex) {
    const reference = from.querySelectorAll("[data-ticket-id]")[oldIndex];
    reference ? from.insertBefore(item, reference) : from.appendChild(item);
  }

  // Recomputes each column's count badge from the cards currently in it.
  updateCounts() {
    this.columnTargets.forEach((column, index) => {
      const count = column.querySelectorAll("[data-ticket-id]").length;
      if (this.countTargets[index]) this.countTargets[index].textContent = count;
    });
  }
}
